import { render, staticRenderFns } from "./ProduksiSlitting.vue?vue&type=template&id=00386571&scoped=true&"
import script from "./ProduksiSlitting.vue?vue&type=script&lang=js&"
export * from "./ProduksiSlitting.vue?vue&type=script&lang=js&"
import style0 from "./ProduksiSlitting.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProduksiSlitting.vue?vue&type=style&index=1&id=00386571&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00386571",
  null
  
)

export default component.exports